import { ReservationsSendEmailRequestParameters } from '@mews-commander/data-access';
import { CommanderThunkAction } from '@mews-commander/types';
import { createFetchAction } from '@mews-commander/utils';

const EMAIL_SEND = 'EMAIL_SEND';

export const sendEmail =
    (values: ReservationsSendEmailRequestParameters): CommanderThunkAction =>
    async (dispatch, _getState, { repositories }) => {
        const promise = repositories.reservations.sendEmail(values);

        return dispatch(createFetchAction(EMAIL_SEND, promise));
    };
